const getters = {
  getActiveExposurePart: state => state.activeExposurePart,
  getExposurePartOptions: state => state.exposurePartOptions,
  getActivePartBar: state => state.activePartBar,
  getPartBarOptions: state => state.partBarOptions,
  getActiveTypeEntityItem: state => state.activeTypeEntityItem,
}

export default getters